import { IconButton } from "@mui/material";
import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import GitHubIcon from "@mui/icons-material/GitHub";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import PhoneIcon from "@mui/icons-material/Phone";
import SvgIcon from "@mui/material/SvgIcon";

import GitlabDarkLogo from "@icons/gitlab-dark.svg";
import GitlabLightLogo from "@icons/gitlab-light.svg";
import { useExtendedTheme } from "@theme/Context";

export type CommunicationMethodProps = {
  name: string;
  link: string;
};

export const getIcon = (name: string) => {
  const { theme } = useExtendedTheme();
  switch (name.toLowerCase()) {
    case "instagram":
      return <InstagramIcon />;
    case "linkedin":
      return <LinkedInIcon />;
    case "github":
      return <GitHubIcon />;
    case "email":
      return <EmailIcon />;
    case "facebook":
      return <FacebookIcon />;
    case "twitter":
      return <TwitterIcon />;
    case "phone":
      return <PhoneIcon />;
    case "gitlab":
      return (
        <SvgIcon>
          {theme.palette.mode === "dark" ? (
            <GitlabLightLogo />
          ) : (
            <GitlabDarkLogo />
          )}
        </SvgIcon>
      );
    default:
      return <LiveHelpIcon />;
  }
};

const CommunicationMethod = (props: CommunicationMethodProps) => {
  const { name = "", link = "" } = props;
  return (
    <>
      <IconButton href={link}>{getIcon(name)}</IconButton>
    </>
  );
};

export default CommunicationMethod;
